import React from 'react';
import { Input, Button } from 'antd';
import { CloseOutlined, SearchOutlined } from '@ant-design/icons';

import DocsLink from '../../docs/DocsLink';

const CompoundSideListSearch = ({ onChange, value, scrolTo }) => {
  const suffix = value ? (
    <Button style={{ border: 'none', padding: 0, height: 'auto' }} onClick={() => onChange(null)}>
      <CloseOutlined />
    </Button>
  ) : null;

  return (
    <div
      style={{
        padding: '5px 5px 5px 15px',
        borderBottom: '1px solid #e0e0e0',
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'flexStart',
        alignItems: 'center',
      }}
    >
      <Input
        placeholder="Search by name"
        prefix={<SearchOutlined />}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        suffix={suffix}
      />
      <DocsLink
        scrolTo={scrolTo}
        styleIcon={{ fontSize: 20, marginLeft: 10, marginRight: 5, color: 'gray' }}
      />
    </div>
  );
};

export default CompoundSideListSearch;
